import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import {
  MibButtonDirective,
  MibIconComponent,
  MibLogoMedinboxComponent,
  MibModalComponent,
} from '@medinbox/angular';

@Component({
  selector: 'mai-cancel-dialog',
  imports: [MibModalComponent, MibLogoMedinboxComponent, MibButtonDirective, MibIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './declined-dialog.html',
})
export class DeclinedDialog {
  readonly dialogRef = inject(DialogRef<void>);
}
